var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-mask"},[_c('div',{staticClass:"outside-mask"}),_vm._v(" "),_c('button',{staticClass:"button",class:{ paused: _vm.value },on:{"click":_vm.toggleButton}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8881809e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideFragment/slideComponents/VideoPlayer/components/PlayButtonMask.vue
// module id = 127
// module chunks = 0